export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'ads_conversion_Contact_Us_1', { 'event_timeout': 2000 });
    }
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/edited_f56f41123546881f553c57dff718a4ca_e6831a6f.jpg"
          alt="Comfortable home testing environment"
          className="w-full h-full object-cover object-center md:object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-2xl">
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Professional ADHD Testing<br />
            <span className="text-violet-300">From The Comfort of Home</span>
          </h1>
          
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Comprehensive, confidential, and convenient online ADHD assessments for teens and adults nationwide.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <a 
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToContact(); }}
              className="bg-violet-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-violet-700 transition-all hover:scale-105 whitespace-nowrap"
            >
              Start Assessment
            </a>
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-semibold border-2 border-white/30 hover:bg-white/20 transition-all whitespace-nowrap"
            >
              Learn More
            </button>
          </div>

          <div className="mt-12 flex flex-wrap gap-8 text-white/80">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-2xl text-violet-300"></i>
              <span className="text-sm font-medium">HIPAA Compliant</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-2xl text-violet-300"></i>
              <span className="text-sm font-medium">48-Hour Results</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
